import { useState } from "react";
import {SchedulerService} from "../../application/services/schedulerService";

const schedulerService = new SchedulerService();
export const useScheduler = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [schedules, setSchedules] = useState(null);

  const getAllSchedules = async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await schedulerService.getAllSchedules();
      if (result.success) {
        setSchedules(result.schedules);
        return { success: true, schedules: result.schedules };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const updateScheduler = async (task, cronExpression) => {
    setLoading(true);
    setError(null);
    setSuccessMessage(null);
    try {
      const result = await schedulerService.updateScheduler(
        task,
        cronExpression,
      );
      if (result.success) {
        setSuccessMessage(result.message);
        return { success: true, message: result.message };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const syncInfrastructure = async () => {
    setLoading(true);
    setError(null);
    setSuccessMessage(null);
    try {
      const result = await schedulerService.syncInfrastructure();
      if (result.success) {
        setSuccessMessage(result.message);
        return { success: true, message: result.message };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const syncPerformance = async () => {
    setLoading(true);
    setError(null);
    setSuccessMessage(null);
    try {
      const result = await schedulerService.syncPerformance();
      if (result.success) {
        setSuccessMessage(result.message);
        return { success: true, message: result.message };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const syncAlerts = async () => {
    setLoading(true);
    setError(null);
    setSuccessMessage(null);
    try {
      const result = await schedulerService.syncAlerts();
      if (result.success) {
        setSuccessMessage(result.message);
        return { success: true, message: result.message };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const syncInvoices = async () => {
    setLoading(true);
    setError(null);
    setSuccessMessage(null);
    try {
      const result = await schedulerService.syncInvoices();
      if (result.success) {
        setSuccessMessage(result.message);
        return { success: true, message: result.message };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const syncMonthlyCosts = async (year, month) => {
    setLoading(true);
    setError(null);
    setSuccessMessage(null);
    try {
      const result = await schedulerService.syncMonthlyCosts(year, month);
      if (result.success) {
        setSuccessMessage(result.message);
        return { success: true, message: result.message };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const syncBackup = async () => {
    setLoading(true);
    setError(null);
    setSuccessMessage(null);
    try {
      const result = await schedulerService.syncBackup();
      if (result.success) {
        setSuccessMessage(result.message);
        return { success: true, message: result.message };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  return {
    getAllSchedules,
    updateScheduler,
    syncInfrastructure,
    syncPerformance,
    syncAlerts,
    syncInvoices,
    syncMonthlyCosts,
    syncBackup,
    schedules,
    loading,
    error,
    successMessage,
  };
};